export function loadScript(url: string, withTimestamp = false) {
  if (withTimestamp) {
    url = `${url}?t=${Date.now()}`;
  }
  return new Promise(function (resolve, reject) {
    // Adding the script tag to the head as suggested before
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;
    script.charset = 'UTF-8';

    script.onload = resolve;
    script.onerror = reject;

    // Fire the loading
    head.appendChild(script);
  });
}
